// extracted by mini-css-extract-plugin
module.exports = {"productName":"Tests_productName__2YL5u","actions":"Tests_actions__4Y6m-","button":"Tests_button__1CwSX"};